import { render, staticRenderFns } from "./HistoryReport.vue?vue&type=template&id=bfa46b8a"
import script from "./HistoryReport.vue?vue&type=script&lang=js"
export * from "./HistoryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports